import { createAction } from "@reduxjs/toolkit";

const addCycleListAsyncAction = createAction("ADD_CYCLE_LIST_ASYNC");

export default addCycleListAsyncAction;
